import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { C, FONT_NUM } from './tokens';

// Small inline pill used for signals, regimes, tiers, triggers.
export const Tag = ({ children, bg, fg, border, sx }) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.4,
      px: 0.85,
      height: 20,
      borderRadius: 0.85,
      bgcolor: bg,
      color: fg,
      border: border ? `1px solid ${border}` : 'none',
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 0.2,
      lineHeight: 1,
      whiteSpace: 'nowrap',
      ...sx,
    }}
  >
    {children}
  </Box>
);

Tag.propTypes = {
  children: PropTypes.node,
  bg: PropTypes.string,
  fg: PropTypes.string,
  border: PropTypes.string,
  sx: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

Tag.defaultProps = {
  children: null,
  bg: undefined,
  fg: undefined,
  border: undefined,
  sx: undefined,
};

// Key/value line used inside the detail drawer cards.
export const DataLine = ({ k, v }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 2, py: 0.7 }}>
    <Typography sx={{ fontSize: 12, color: '#64748b', fontWeight: 500 }}>{k}</Typography>
    <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: C.ink, fontFamily: FONT_NUM }}>{v}</Typography>
  </Box>
);

DataLine.propTypes = {
  k: PropTypes.node.isRequired,
  v: PropTypes.node,
};

DataLine.defaultProps = {
  v: '—',
};

// Compact uppercased section header used inside cards.
export const SectionLabel = ({ children }) => (
  <Typography sx={{ fontSize: '0.68rem', fontWeight: 800, color: '#334155', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
    {children}
  </Typography>
);

SectionLabel.propTypes = {
  children: PropTypes.node,
};

SectionLabel.defaultProps = {
  children: null,
};

// Tile used in the mobile summary grid.
export const MobileSummaryCard = ({ label, value, subtext, accent }) => (
  <Box sx={{ p: 1.05, borderRadius: 1.5, border: `1px solid ${C.border}`, bgcolor: '#fff' }}>
    <Typography sx={{ fontSize: '0.58rem', color: C.mutedSoft, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
      {label}
    </Typography>
    <Typography sx={{ mt: 0.35, fontSize: '0.95rem', fontWeight: 900, color: accent, fontFamily: FONT_NUM, lineHeight: 1.1 }}>
      {value}
    </Typography>
    {subtext ? (
      <Typography sx={{ mt: 0.35, fontSize: '0.62rem', color: C.muted, lineHeight: 1.35 }}>
        {subtext}
      </Typography>
    ) : null}
  </Box>
);

MobileSummaryCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  subtext: PropTypes.node,
  accent: PropTypes.string,
};

MobileSummaryCard.defaultProps = {
  subtext: undefined,
  accent: C.ink,
};
